import React from "react";
import Vocabulary, { getVocabulary } from "components/Vocabulary";
import UserAPI from "restAPI/UserAPI";
import { EMAIL_REGEX } from "constants/RegExp";

export const ROLE_TENANT = "TENANT";
export const ROLE_TEAMS = "TEAMS";

export const  ROLE_SCOPE = {
    [ROLE_TENANT]: {label: 'Account Level', value: ROLE_TENANT},
    [ROLE_TEAMS]: {label: <><Vocabulary name="team" isPlural={true} />  Level</>, value: ROLE_TEAMS}
}

export const TENANT_ADMIN_TOOLTIP =
    "Account Admin's permissions cannot be viewed since they have unrestricted access throughout the platform.";

export const ALL_OWNER_TYPES = [
    "businessOwner",
    "complianceOwner",
    "engineeringOwner",
    "securityOwner",
    "supportOwner",
];

export const getAllOwnerMenuOptions = () =>
    ALL_OWNER_TYPES.map((type) => ({ label: getVocabulary(type), value: type }));

export const emailFieldRules = (editMode, validateAPIRef) => {
  let debounceTimer;

  return [
    {
      required: true,
      message: "Email is required"
    },
    {
      validator: (_, value) => {
        if (!EMAIL_REGEX.test(value)) {
          return Promise.reject('Invalid Email');
        }
        if (!editMode && typeof value === "string"  && value?.trim().length !== 0) {
            const email = value.trim();
          
          if (validateAPIRef.current) {
            validateAPIRef.current();
          }
          clearTimeout(debounceTimer);

          return new Promise((resolve, reject) => {
            debounceTimer = setTimeout(() => {
              const { promise, cancel } = UserAPI.validate({ email: email });
              validateAPIRef.current = cancel;

              promise
                .then((response) => {
                  if (response && response.data === false) {
                    reject("Email already used");
                  } else {
                    resolve()
                  }
                })
                .catch(() => {
                  reject("Email already used");
                });
            }, 800);
          });
        }
        return Promise.resolve();
      },
    },
  ];
};